
export class CentroDataModel {


  localidad: string;



}
